module.exports = __webpack_public_path__ + "img/phone-2.730e26f3.jpg";